import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 19,
  medium: 16,
  small: 12,
  xSmall: 9
};
const ArrowRightBoldIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 16 16",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3.62971L5.49483 3L11 8L5.49483 13L5 12.3982L9.76294 8L5 3.62971Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3.62971L5.49483 3L11 8L5.49483 13L5 12.3982L9.76294 8L5 3.62971Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3.62971L5.49483 3L11 8L5.49483 13L5 12.3982L9.76294 8L5 3.62971Z",
        stroke: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3.62971L5.49483 3L11 8L5.49483 13L5 12.3982L9.76294 8L5 3.62971Z",
        stroke: "currentColor"
      }
    )
  );
};
ArrowRightBoldIcon.iconName = "ArrowRightBoldIcon";

export { ArrowRightBoldIcon };
